import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/company/wht`;

// ---- Payee master ----

const listPayees = async (opts = {}) => {
  const response = await axios.get(`${API_URL}/payee`, {
    params: opts.all ? { active: 'all' } : {},
  });
  return response.data;
};

const createPayee = async (payee) => {
  const response = await axios.post(`${API_URL}/payee`, payee);
  return response.data;
};

const updatePayee = async (id, payee) => {
  const response = await axios.patch(`${API_URL}/payee/${id}`, payee);
  return response.data;
};

// Attach a payee's ID card, for the lower half of the ใบสำคัญจ่าย. The stored
// location is never returned by the API — listPayees reports only `hasIdCard` —
// so a national ID cannot be reached by anyone holding a URL.
const uploadPayeeIdCard = async (payeeId, file) => {
  const formData = new FormData();
  formData.append('images', file);
  const response = await axios.post(`${BACKEND_URL}/api/admin/wht-payee/${payeeId}/id-card`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// Fetch the ID card for display. It is streamed by the server rather than linked,
// so it arrives as a blob and becomes a local object URL — the stored location is
// never exposed to the page. Revoke the URL when done with it.
const fetchPayeeIdCardUrl = async (payeeId) => {
  const response = await axios.get(`${BACKEND_URL}/api/admin/wht-payee/${payeeId}/id-card`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};

// ---- Certificates ----

// items: [{ datePaid, amount }] -> creates one certificate per pair.
const createCertificates = async (payeeId, items) => {
  const response = await axios.post(`${API_URL}/certificate`, { payeeId, items });
  return response.data;
};

const listCertificates = async ({ payeeId, year, month }) => {
  const response = await axios.get(`${API_URL}/certificate`, { params: { payeeId, year, month } });
  return response.data;
};

const deleteCertificate = async (id) => {
  const response = await axios.delete(`${API_URL}/certificate/${id}`);
  return response.data;
};

// Opens the combined print PDF in a new tab. Select by payee + month, or explicit ids.
// withVouchers: each payroll certificate is followed by its ใบสำคัญจ่าย (1 copy),
// so a payment's paperwork prints together. Off by default — the Salary Payment
// "50 ทวิ" button prints the certificate alone.
const openCertificatesPdf = async ({ payeeId, year, month, ids, withVouchers = false }) => {
  const response = await axios.get(`${API_URL}/certificate/pdf`, {
    params: {
      payeeId, year, month,
      ids: ids ? ids.join(',') : undefined,
      withVouchers: withVouchers ? 1 : undefined,
    },
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  window.open(url, '_blank');
  // Revoke a little later so the new tab has time to load the blob.
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

const WhtCertificateService = {
  listPayees,
  createPayee,
  updatePayee,
  uploadPayeeIdCard,
  fetchPayeeIdCardUrl,
  createCertificates,
  listCertificates,
  deleteCertificate,
  openCertificatesPdf,
};

export default WhtCertificateService;
